import type { ConsoleClientCredits } from '@plato/shared';
import { formatCredits, formatPercent } from './format.ts';

export const NEAR_LIMIT = 0.8;

type Severity = 'ok' | 'near' | 'reached';

export function severityOf(ratio: number): Severity {
  if (ratio >= 1) return 'reached';
  return ratio >= NEAR_LIMIT ? 'near' : 'ok';
}

const STATE_LABEL: Readonly<Record<Severity, string | null>> = {
  ok: null,
  near: 'Near limit',
  reached: 'Limit reached',
};

export function LimitMeter({ client }: { client: ConsoleClientCredits }) {
  if (client.limit === null) return <span className="muted">No limit</span>;
  if (client.organization === null) {
    return <span className="muted">{formatCredits(client.limit.monthly_credit_micros)} each</span>;
  }
  const limit = client.limit.monthly_credit_micros;
  const ratio = limit === 0 ? 1 : client.credit_micros / limit;
  const severity = severityOf(ratio);
  const state = STATE_LABEL[severity];
  return (
    <div className="meter-cell">
      <div className={`meter meter-${severity}`} aria-hidden="true">
        <span style={{ width: `${Math.min(100, ratio * 100)}%` }} />
      </div>
      <span className="meter-value">
        {formatPercent(ratio)} of {formatCredits(limit)}
        {state !== null && <span className={`chip chip-${severity}`}>{state}</span>}
      </span>
    </div>
  );
}
